(function() {
  const metafield = window.__megaMenuData;
  if (!metafield || !metafield.menu) return;

  const menu = metafield.menu;

  menu.forEach(function(item) {
    // Находим пункт меню по тексту
    const navLinks = document.querySelectorAll('.header__menu-item');
    navLinks.forEach(function(link) {
      if (link.textContent.trim().toUpperCase() === item.title.toUpperCase()) {

        // Оборачиваем в wrapper
        const wrapper = document.createElement('div');
        wrapper.classList.add('mega-menu-wrapper');
        link.parentNode.insertBefore(wrapper, link);
        wrapper.appendChild(link);

        // Создаём dropdown
        const dropdown = document.createElement('div');
        dropdown.classList.add('mega-menu-dropdown');

        // Колонки
        if (item.columns && item.columns.length) {
          const columnsEl = document.createElement('div');
          columnsEl.classList.add('mega-menu-columns');

          item.columns.forEach(function(col) {
            const colEl = document.createElement('div');
            colEl.classList.add('mega-menu-column');

            // Заголовок колонки
            const colTitle = document.createElement('a');
            colTitle.classList.add('mega-menu-column__title');
            colTitle.href = col.url;
            colTitle.textContent = col.title;
            colEl.appendChild(colTitle);

            // Дети (3й уровень)
            if (col.children && col.children.length) {
              const childList = document.createElement('ul');
              childList.classList.add('mega-menu-children');

              col.children.forEach(function(child) {
                const li = document.createElement('li');
                const a = document.createElement('a');
                a.href = child.url;
                a.textContent = child.title;
                li.appendChild(a);
                childList.appendChild(li);
              });

              colEl.appendChild(childList);
            }

            columnsEl.appendChild(colEl);
          });

          dropdown.appendChild(columnsEl);
        }

        // Баннер
        if (item.banner && item.banner.image) {
          const bannerEl = document.createElement('div');
          bannerEl.classList.add('mega-menu-banner');

          const bannerLink = document.createElement('a');
          bannerLink.href = item.banner.link || '#';

          const bannerImg = document.createElement('img');
          bannerImg.src = item.banner.image;
          bannerImg.alt = item.banner.alt || '';

          bannerLink.appendChild(bannerImg);
          bannerEl.appendChild(bannerLink);
          dropdown.appendChild(bannerEl);
        }

        wrapper.appendChild(dropdown);

        // Мобильный аккордеон
        link.addEventListener('click', function(e) {
          if (window.innerWidth <= 768) {
            e.preventDefault();
            wrapper.classList.toggle('is-open');
          }
        });
      }
    });
  });
})();